
import { Swiper, SwiperCore, SwiperSlide } from "swiper-vue2";
import { Navigation } from "swiper";
import NextArrowSvg from "@/components/svg/NextArrowSvg";
import PrevArrowSvg from "@/components/svg/PrevArrowSvg";
import { getImageByPosition, setAttributeToElements } from "~/utils";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation]);
export default {
  components: {
    Swiper,
    SwiperSlide,
    NextArrowSvg,
    PrevArrowSvg,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    activeItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      sliderInstance: null,
      isMounted: false,
      navigation: false,
    };
  },
  computed: {
    activeItemIdx() {
      return this.data.materials.findIndex(
        (el) => el.sku === this.activeItem.sku
      );
    },
    mountedAndData() {
      return this.isMounted && this.data?.materials?.length;
    },
    swiperOptions() {
      return {
        slidesPerView: 2,
        spaceBetween: 0,
        roundLengths: true,
        navigation: this.navigation,
        breakpoints: {
          320: {
            slidesPerView: 3,
            allowTouchMove: true,
          },
          440: {
            slidesPerView: 4,
            allowTouchMove: true,
          },
          580: {
            slidesPerView: 6,
            allowTouchMove: true,
          },
          768: {
            slidesPerView: 5,
            allowTouchMove: true,
          },
          992: {
            slidesPerView: 5,
            allowTouchMove: false,
          },
          1400: {
            slidesPerView: 5,
            allowTouchMove: false,
          },
        },
      };
    },
    currentSlidesPerView() {
      return this.sliderInstance ? this.sliderInstance.params.slidesPerView : 2;
    },
    showNavigation() {
      return this.data?.materials?.length > this.currentSlidesPerView;
    },
  },
  watch: {
    mountedAndData: {
      handler(val) {
        if (val) {
          setAttributeToElements("button.hidden-ssr-link", "tabindex", "0");
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.sliderInstance = this.$refs.swiper.swiperRef;
    if (this.sliderInstance.activeIndex < this.activeItemIdx + 1) {
      this.sliderInstance.slideTo(
        this.activeItemIdx - this.sliderInstance.activeIndex + 1
      );
    }
    this.navigation = {
      prevEl: this.$refs.prev,
      nextEl: this.$refs.next,
    };
    this.isMounted = true;
  },
  methods: {
    getImageByPosition,
  },
};
